export enum AadUserPresence {
    online,
    away,
    busy,
    doNotDisturb,
    offline,
}
